// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { Button, Modal, Table } from "antd";
// import {
//   Avatar_06,
//   Avatar_07,
//   Avatar_14,
//   Avatar_18,
//   Avatar_19,
//   Avatar_22,
//   Avatar_26,
//   Avatar_29,
// } from "../../../Routes/ImagePath";
// import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
// import SearchBox from "../../../components/SearchBox";
// import Breadcrumbs from "../../../components/Breadcrumbs";
// import ClientsFilter from "../../../components/ClientsFilter";
// import { LeadsModalPopup } from "./LeadsModalPopup";
// import LeadsFilter from "./LeadsFilter";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import LeadsDeleteModal from "../../../components/modelpopup/LeadsDeleteModal";
// import moment from "moment";

// const LeadsList = () => {
//   const [leads, setLeads] = useState([]);
//   const [allLeadsData, setAllLeadsData] = useState(leads.length > 0 && leads);

//   const parentFunctionLeads = (data) => {
//     setAllLeadsData(data);
//   };

//   console.log("m,nm,n,", allLeadsData);

//   const LeadsFetchFunctionData = async () => {
//     try {
//       const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
//       const response = await axios.get(
//         `${Api_Url}api/v1/Lead?UserId=${userId}&PageNumber=1&PageSize=100`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user"))?.accessToken
//             }`,
//           },
//         }
//       );
//       console.log("res", response.data.data);
//       setLeads(response.data.data);
//       setAllLeadsData(response.data.data)
//     } catch (error) {}
//   };

//   useEffect(() => {
//     LeadsFetchFunctionData();
//   }, []);

//   const [deleteId, setdeleteId] = useState(null);

//   const HandleDeleteFunc = async () => {
//     try {
//       const response = await axios.delete(`${Api_Url}api/v1/Lead/${deleteId}`, {
//         headers: {
//           Authorization: `Bearer ${
//             JSON.parse(sessionStorage.getItem("user")).accessToken
//           }`,
//         },
//       });
//       console.log(response);
//       LeadsFetchFunctionData();
//     } catch (error) {
//       return error.message;
//     }
//   };

//   const columns = [
//     {
//       title: "Branch",
//       dataIndex: "branchName",
//       sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     },
//     {
//       title: "FirstName",
//       dataIndex: "firstName",
//       sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     },
//     {
//       title: "LastName",
//       dataIndex: "lastName",
//       sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     },
//     {
//       title: "Pincode",
//       dataIndex: "pinCode",
//       sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     },
//     {
//       title: "ProductName",
//       dataIndex: "productName",
//       sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     },
//     {
//       title: "Amount",
//       dataIndex: "amount",
//       sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     },
//     {
//       title: "PanNumber",
//       dataIndex: "panNumber",
//       sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     },
//     {
//       title: "Mobile",
//       dataIndex: "mobile",
//       sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     },
//     {
//       title: "MobileVerified",
//       dataIndex: "mobile",
//       sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     },
//     {
//       title: "SourceName",
//       dataIndex: "sourceName",
//       sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     },
//     // {
//     //   title: "CustomerInterested",
//     //   dataIndex: "isCustomerInterested",
//     //   sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     // },
//     {
//       title: "StatusId",
//       dataIndex: "statusId",
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "SsoId",
//       dataIndex: "ssoId",
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "KioskCode",
//       dataIndex: "kioskCode",
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "ERequestId",
//       dataIndex: "eRequestId",
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "ERequestTime",
//       dataIndex: "eRequestTime",
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "EReceiptNo",
//       dataIndex: "eReceiptNo",
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "ETransactionId",
//       dataIndex: "eTransactionId",
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "ETransactionStatus",
//       dataIndex: "eTransactionStatus",
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "EMessage",
//       dataIndex: "eMessage",
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "ETransactionStatus",
//       dataIndex: "eTransactionStatus",
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "Created",
//       dataIndex: "created",
//       render: (text) => {
//         return moment(text).format("MMMM Do YYYY, h:mm:ss a");
//       },
//       sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     },
//     {
//       title: "View",
//       dataIndex: "actions",
//       render: (text, record) => (
//         <Button
//           className="btn-property"
//           onClick={() => handleViewClick(record)}
//         >
//           <i className="fa-solid fa-eye"></i>
//         </Button>
//       ),
//     },
//   ];
//   return (
//     <>
//       <div className="page-wrapper">
//         <div className="content container-fluid">
//           <div className="page-header">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <h3 className="page-title">Leads</h3>
//                 <ul className="breadcrumb">
//                   <li className="breadcrumb-item">
//                     <Link to="/dashboard">Dashboard</Link>
//                   </li>
//                   <li className="breadcrumb-item active">Leads</li>
//                 </ul>
//               </div>
//               <div className="col-md-8 float-end ms-auto">
//                 <div className="d-flex title-head">
//                   <div className="view-icons">
//                     <div className="form-sort">
//                       <Link to="#" className="list-view btn btn-link">
//                         <i className="las la-file-export" />
//                         Export
//                       </Link>
//                     </div>
//                   </div>
//                   <Breadcrumbs
//                     modal="#add_client"
//                     name="Add Leads"
//                     Linkname="/clients"
//                     Linkname1="/clients-list"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Page Header */}
//           {/* <div className="d-flex justify-content-between">
//             <div className="col-md-4">
//               <h3 className="page-title">Activities</h3>
//               <ul className="breadcrumb">
//                 <li className="breadcrumb-item">
//                   <Link to="/dashboard">Dashboard</Link>
//                 </li>
//                 <li className="breadcrumb-item active">Activities</li>
//               </ul>
//             </div>

//             <div className="d-flex title-head">
//               <div className="view-icons">
//                 <div className="form-sort">
//                   <Link
//                     to="#"
//                     className="list-view btn btn-link"
//                     data-bs-toggle="modal"
//                     data-bs-target="#export"
//                   >
//                     <i className="las la-file-export" />
//                     Export
//                   </Link>
//                 </div>
//               </div>

//             </div>

//             <Breadcrumbs
//               modal="#add_client"
//               name="Add Leads"
//               Linkname="/clients"
//               Linkname1="/clients-list"
//             />
//           </div> */}
//           {/* /Page Header */}
//           <LeadsFilter parentFunctionLeads={parentFunctionLeads} />

//           <div className="row">
//             <div className="col-md-12">
//               <div className="table-responsive">
//                 <SearchBox />
//                 <Table
//                   className="table-striped"
//                   style={{ overflowX: "auto" }}
//                   columns={columns}
//                   dataSource={allLeadsData}
//                   rowKey={(record) => record.id}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <LeadsModalPopup LeadsFetchFunctionData={LeadsFetchFunctionData} />
//       <LeadsDeleteModal
//         Name="Delete Client"
//         HandleDeleteFunction={HandleDeleteFunc}
//       />
//     </>
//   );
// };

// export default LeadsList;

// help ful code

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, Table } from "antd";
import {
  Avatar_06,
  Avatar_07,
  Avatar_14,
  Avatar_18,
  Avatar_19,
  Avatar_22,
  Avatar_26,
  Avatar_29,
} from "../../../Routes/ImagePath";
import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
import SearchBox from "../../../components/SearchBox";
import Breadcrumbs from "../../../components/Breadcrumbs";
import ClientsFilter from "../../../components/ClientsFilter";
// import { LeadsModalPopup } from "./LeadsModalPopup";
import LeadsFilter from "./LeadsFilter";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import LeadsDeleteModal from "../../../components/modelpopup/LeadsDeleteModal";
import moment from "moment";
import YourModalComponent from "./YourModalComponent";
import { LeadsModalPopup } from "./LeadsModalPopup";

const LeadsList = () => {
  const [leads, setLeads] = useState([]);
  const [allLeadsData, setAllLeadsData] = useState(leads.length > 0 && leads);

  const parentFunctionLeads = (data) => {
    setAllLeadsData(data);
  };

  console.log("m,nm,n,", allLeadsData);

  const LeadsFetchFunctionData = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/Lead?UserId=${userId}&PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      console.log("res", response.data.data);
      setLeads(response.data.data);
      setAllLeadsData(response.data.data);
    } catch (error) {}
  };

  useEffect(() => {
    LeadsFetchFunctionData();
  }, []);

  const [deleteId, setdeleteId] = useState(null);

  const HandleDeleteFunc = async () => {
    try {
      const response = await axios.delete(`${Api_Url}api/v1/Lead/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      console.log(response);
      LeadsFetchFunctionData();
    } catch (error) {
      return error.message;
    }
  };

  // Add By Deepak Because It's is not added by before
  const handleViewClick = (date) => {        
    console.log("This Is Not Valid", date);
    
  };

  const columns = [
    {
      title: "Branch",
      dataIndex: "branchName",
      sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    },
    {
      title: "FirstName",
      dataIndex: "firstName",
      sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    },
    {
      title: "LastName",
      dataIndex: "lastName",
      sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    },
    {
      title: "Pincode",
      dataIndex: "pinCode",
      sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    },
    {
      title: "ProductName",
      dataIndex: "productName",
      sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    },
    {
      title: "PanNumber",
      dataIndex: "panNumber",
      sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    },
    {
      title: "MobileVerified",
      dataIndex: "mobile",
      sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    },
    {
      title: "SourceName",
      dataIndex: "sourceName",
      sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    },
    // {
    //   title: "CustomerInterested",
    //   dataIndex: "isCustomerInterested",
    //   sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    // },
    {
      title: "StatusId",
      dataIndex: "statusId",
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "SsoId",
      dataIndex: "ssoId",
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "KioskCode",
      dataIndex: "kioskCode",
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "ERequestId",
      dataIndex: "eRequestId",
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "ERequestTime",
      dataIndex: "eRequestTime",
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "EReceiptNo",
      dataIndex: "eReceiptNo",
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "ETransactionId",
      dataIndex: "eTransactionId",
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "ETransactionStatus",
      dataIndex: "eTransactionStatus",
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "EMessage",
      dataIndex: "eMessage",
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "ETransactionStatus",
      dataIndex: "eTransactionStatus",
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "Created",
      dataIndex: "created",
      render: (text) => {
        return moment(text).format("MMMM Do YYYY, h:mm:ss a");
      },
      sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    },
    {
      title: "View",
      dataIndex: "actions",
      render: (text, record) => (
        <Button
          className="btn-property"
          onClick={() => handleViewClick(record)}
        >
          <i className="fa-solid fa-eye"></i>
        </Button>
      ),
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mb-0">Leads</h3>
              <button
                className="btn btn-primary submit-btn mb-2"
                onClick={handleOpenModal}
              >
                Add Leads
              </button>
              {isModalOpen && (
                <LeadsModalPopup
                  onClose={handleCloseModal}
                  LeadsFetchFunctionData={LeadsFetchFunctionData}
                />
              )}
            </div>
          </div>
          <LeadsFilter parentFunctionLeads={parentFunctionLeads} />

          <div className="row mt-4">
            <div className="col-md-12">
              <div className="table-responsive">
                <SearchBox />
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={allLeadsData}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <LeadsModalPopup LeadsFetchFunctionData={LeadsFetchFunctionData} /> */}
      <LeadsDeleteModal
        Name="Delete Client"
        HandleDeleteFunction={HandleDeleteFunc}
      />
    </>
  );
};

export default LeadsList;
